import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

const Welcome = () => {
  const navigate = useNavigate();

  const memberTypes = [
    {
      type: 'senior',
      label: 'I am a Senior Member',
      sublabel: 'Age 50+ looking to connect',
      emoji: '🧓',
      color: '#FF6B35',
      bg: '#FFF3EE'
    },
    {
      type: 'family',
      label: 'I am a Family Member',
      sublabel: 'Supporting an elderly loved one',
      emoji: '👨‍👩‍👧',
      color: '#4CAF50',
      bg: '#F1F8F1'
    },
    {
      type: 'volunteer',
      label: 'I am a Volunteer',
      sublabel: 'Help seniors in the community',
      emoji: '🤝',
      color: '#2196F3',
      bg: '#EEF5FD'
    }
  ];

  return (
    <div className="page-container no-nav" style={{ background: 'linear-gradient(180deg, #FFF8F0 0%, #FFE8DC 100%)' }}>
      <div style={{ padding: '0 20px 40px', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

        {/* Top decoration */}
        <div style={{ textAlign: 'center', paddingTop: '48px', paddingBottom: '16px' }}>
          {/* Decorative emojis */}
          <div style={{ fontSize: '28px', marginBottom: '12px', letterSpacing: '8px', opacity: 0.7 }}>
            🌸 🌼 🌺
          </div>

          {/* Logo */}
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <Logo size={180} />
          </div>

          {/* App name */}
          <h1 style={{
            fontSize: '32px',
            fontWeight: '800',
            color: '#FF6B35',
            letterSpacing: '0.5px',
            marginBottom: '8px'
          }}>
            SaathiCircle
          </h1>

          {/* Tagline */}
          <p style={{
            fontSize: '17px',
            color: '#666',
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Friends for Every Phase of Life
          </p>

          <p style={{
            fontSize: '14px',
            color: '#999',
            fontStyle: 'italic'
          }}>
            हर पल का साथी
          </p>
        </div>

        {/* Feature highlights */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          margin: '16px 0 24px',
          flexWrap: 'wrap'
        }}>
          {[
            { icon: '💬', label: 'Community Chat' },
            { icon: '🏃', label: 'Local Events' },
            { icon: '🏥', label: 'Health Tracking' },
            { icon: '🆘', label: 'SOS Alerts' }
          ].map((f) => (
            <div key={f.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
              <span style={{ fontSize: '24px' }}>{f.icon}</span>
              <span style={{ fontSize: '11px', color: '#888', fontWeight: 500 }}>{f.label}</span>
            </div>
          ))}
        </div>

        {/* Section title */}
        <div style={{ marginBottom: '12px' }}>
          <p style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#2D2D2D',
            textAlign: 'center',
            marginBottom: '4px'
          }}>
            Join as...
          </p>
          <p style={{ fontSize: '13px', color: '#999', textAlign: 'center' }}>
            Select your role to get started
          </p>
        </div>

        {/* Member type buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {memberTypes.map((m) => (
            <button
              key={m.type}
              onClick={() => navigate(`/register?type=${m.type}`)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                padding: '16px 20px',
                background: m.bg,
                border: `2px solid ${m.color}30`,
                borderRadius: '16px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                textAlign: 'left',
                fontFamily: "'Hind', 'Poppins', sans-serif"
              }}
              onTouchStart={(e) => e.currentTarget.style.transform = 'scale(0.97)'}
              onTouchEnd={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <span style={{
                width: '52px',
                height: '52px',
                background: 'white',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '26px',
                boxShadow: `0 2px 8px ${m.color}20`,
                flexShrink: 0
              }}>
                {m.emoji}
              </span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '17px', fontWeight: '700', color: m.color, marginBottom: '2px' }}>
                  {m.label}
                </div>
                <div style={{ fontSize: '13px', color: '#777' }}>
                  {m.sublabel}
                </div>
              </div>
              <span style={{ color: m.color, fontSize: '20px' }}>→</span>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div style={{ marginTop: 'auto', paddingTop: '32px', textAlign: 'center' }}>
          <p style={{ fontSize: '13px', color: '#bbb' }}>
            By joining, you agree to our community guidelines
          </p>
          <p style={{ fontSize: '12px', color: '#ccc', marginTop: '4px' }}>
            🔒 Your privacy is protected
          </p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
